import { createAsyncThunk } from '@reduxjs/toolkit';

import { SpecialtiesResponseSchema } from '../types/VendorsSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchAllSpecialties = createAsyncThunk<
    SpecialtiesResponseSchema,
    null,
    ThunkConfig<string>
>('vendors/allListSpecialties', async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<SpecialtiesResponseSchema>(
            `/v1/vendors/specialities`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
